import {Component, Input, OnInit} from '@angular/core';
import {LokijsService} from '../../services/database/lokijs.service';
import {DocumentModel} from '../../models/document.model';
import {ConfigurationService} from '../../services/configuration.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {PopulateTasksService} from '../../services/workshopServices/populate-tasks.service';
import { AngularDelegate } from '@ionic/angular';

@Component({
    selector: 'details-existing-job',
    templateUrl: './details-existing-job.component.html',
    styleUrls: ['./details-existing-job.component.scss'],
})
export class DetailsExistingJobComponent implements OnInit {
    @Input() document: DocumentModel;
    engineerList: any[];
    jobStatusList: any[] = [];
    restrictedJobTypes: any[] = [];
    jobTypeList: any[] = [];
    jobStatus: any;
    jobTypeId: any;
    display = false;
    buttonText = 'Show';
    configuration: ConfigurationModel;

    constructor(private loki: LokijsService,
                private configurationService: ConfigurationService,
                private populateTaks: PopulateTasksService) {
    }

    async ngOnInit() {
        if (!(this.document.$loki)) {
            this.display = true;
            this.buttonText = 'Hide';
        }
        console.log(this.document.serviceJob.engineer);
        this.engineerList = await this.loki.getTable('engineer', 'id').chain().simplesort('id').data();
        this.configuration = await this.configurationService.getConfiguration();
        this.jobTypeList = await this.loki.getTable('jobtype', 'id').chain().simplesort('id').data();
        this.checkRestrictedJobTypes();
        this.jobStatusList = await this.loki.getTable('jobstatuslist', 'id').chain().simplesort('id').data();
        console.log(this.jobTypeList);

        this.jobTypeId = this.document.serviceJob.jobTypeId;

        // if new job on phone set status to assigned
        if (!(this.document.$loki)) {
            this.jobStatus = 2; // assigned
        }else{
            this.jobStatus = this.document.serviceJob.jobStatus;
        }
        
       

    }

    updateJobType(event) {
        this.document.serviceJob.jobTypeId = event.detail.value;
        this.document.serviceJob.tasks = this.populateTaks.populateTasks(this.document.serviceJob.servicedItem.pdesc, event.detail.value);
        console.log(this.document.serviceJob.jobTypeId);
    }

    updateJobStatus(event) {
        this.document.serviceJob.jobStatus = event.detail.value;
    }

    updateEngineer(event) {
        this.document.serviceJob.engineer = event.detail.value;
        console.log(event.detail.value);
    }

    // TODO check if tasks were complete
    checkRestrictedJobTypes() {
        if (this.document.serviceJob.jobNumber === 0) {
            this.restrictedJobTypes = this.configurationService.getMobileConfiguration().mobilehireRestrictServiceJobTypes;

            for (let i = 0; i < this.jobTypeList.length; i++) {
                if (this.restrictedJobTypes.includes(this.jobTypeList[i].id)) {
                    this.jobTypeList.splice(i, 1);
                }
            }
        }
    }
}
